import environment from "../../../common/environment";
import { getFacetLabel } from "../../../common/utils/search-v2-util";
import { facetSorter } from "../../search/utils/facet.util";
import { SearchV2Facet, SearchV2FacetValue } from "../interface/search-v2.interface";
import { PerformSearchV2Params } from "../thunks/perform-search-v2.thunk";

export function getSearchV2ApiCall(params: PerformSearchV2Params) {
  const url = `${environment().searchV2Api}` + "/search";
  //const body = params;
  const body = buildRequestPayload(params);

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    },
    body: JSON.stringify(body),
  })
    .then((res) => (res.status <= 399 ? res.json() : false))
    .then((json) => {
      if (json) {
        if (json.facets) {
          json.facets.forEach((facet: SearchV2Facet) => {
            if (['PRODUCT_SCHOOL_LEVEL_PATH'].indexOf(facet.name) === -1)
              facet.facetValues.sort((v1, v2) => facetSorter(facet.name, v1, v2));

            facet.label = getFacetLabel(facet.name);

            facet.facetValues.forEach((value: SearchV2FacetValue) => {
              value.label = getFacetLabel(value.name);
              if (
                params.fieldValueFilter &&
                params.fieldValueFilter[facet.name] &&
                params.fieldValueFilter[facet.name].includes(value.name)
              ) {
                value.selected = true;
              }

              if (value.children) {
                value.children.sort((v1, v2) => facetSorter(value.name, v1, v2));
                value.children.forEach((child: SearchV2FacetValue) => {
                  value.label = getFacetLabel(value.name);
                  if (
                    params.fieldValueFilter &&
                    params.fieldValueFilter[facet.name] &&
                    params.fieldValueFilter[facet.name].includes(child.name)
                  ) {
                    child.selected = true;
                  }
                });
              }
            });
          });
        }
        return json;
      }
      return false;
    });
}

function buildRequestPayload(params: PerformSearchV2Params) {
  let page = params.start;
  if (page && page > 1) {
    const pageNo = (page - 1) / params.pageLength! + 1;
    if (Number.isInteger(pageNo)) {
      page = pageNo;
    }
  }

  const body = {
    searchTerms: params.searchTerms,
    fieldValueFilter: convert(params.fieldValueFilter),
    pageLength: params.pageLength || 10,
    start: page || 1,
  };
  return body;
}

type InputStructure = { [key: string]: Array<string> };
type OutputStructure = { all: Array<{ [key: string]: string[] }> };

function convert(input: InputStructure | undefined): OutputStructure | undefined {
  const output: OutputStructure = {
    all: [],
  };
  
  if (input) {
    for (const key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key)) {
        const values = input[key];
        const innerObject: { [innerKey: string]: string[] } = {};
        innerObject[key] = values;
        output.all.push(innerObject);
      }
    }
  }
  return output;
}
